module.exports = "https://static.im-cdn.com/mjc/storefront/Spring/static/media/FacebookFoot.28a0cc16.svg";